import { Component, Input, OnInit } from '@angular/core';
import { RentalObjectInfo, ComponentBase, ObjectTypeInfo, PriceModel, RentalInfo, RentalStatus, RentalObjectTypeAttributes } from 't4core';
import * as moment from 'moment';
import { BookingService } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';

@Component({
    selector: 'app-booking-option',
    templateUrl: './booking-option.component.html',
    styleUrls: ['./booking-option.component.css'],
    standalone: false
})
export class BookingOptionComponent extends ComponentBase implements OnInit {
 public object: RentalObjectInfo;
  @Input() public type: ObjectTypeInfo;
  @Input() public booking: RentalInfo;


  public typeImage: string;

  public showPrice: boolean = true;
  public Price: PriceModel;
  public loadingPrice: boolean = true;
  public dimensions: RentalObjectTypeAttributes[];
  public weights: RentalObjectTypeAttributes[];

  constructor(public bookingService: BookingService, private appService: AppIntegrationService, private appSettings: AppSettingsService) {
    super();
  }
  async ngOnInit() {
    var priceInfo = await this.bookingService.getPriceInfo();
    if (priceInfo && (priceInfo as any).UsesGpsBasedBookingFee) this.showPrice = false;
    this.getPrice();

    if (this.booking?.ObjectId) await this.getObject();
    else if (this.type == null) await this.getType();

    const attributes = this.type?.Attributes ?? [];

    this.dimensions = attributes.filter((item: any) =>
      ['Length', 'Width', 'Height'].includes(item.Key)
    );
    this.weights = attributes.filter((item: any) =>
      ['MaxLoad', 'TotalWeight'].includes(item.Key)
    );
  
  }

  private async getType() {
    if (this.booking.PrimaryType?.Attributes?.length) {
      this.type = this.booking.PrimaryType;
    } else if (this.booking.PrimaryObjectTypeId) {
      this.type = this.booking.PrimaryType = await this.Api.get<ObjectTypeInfo>("/RentalObject/GetTypeInfo", { objectType: this.booking.PrimaryObjectTypeId });
    } else if (this.booking.PrimaryType) {
      this.type = this.booking.PrimaryType;
    }

    this.typeImage = this.type?.PictureUri;
  }

  private async getObject() {
    if (!this.booking.ObjectId) return;
    this.object = this.booking.RentalObject = await this.Api.get<RentalObjectInfo>("/RentalObject/GetObjectInfo", { objectId: this.booking.ObjectId });
  }

  private async getPrice() {
    if (!this.booking || !this.showPrice) return;

    this.loadingPrice = true;

    var currentCoordinates = await this.appService.getCoordinates();
    if (this._isDestroyed) return;

    // TODO Can the one property we actually use - discountableTotalPrice - be returned with GetAllTypes instead?
    let price: PriceModel = await this.Api.get<PriceModel>("/Price/GetRentalPrice",
      {
        pickupTime: this.booking.PickupTime?.toISOString() ?? moment().toISOString(),
        returnTime: this.booking.ReturnTime.toISOString(),
        objectTypeId: this.booking.PrimaryObjectTypeId,
        pickupLocationId: this.booking.PickupLocation.Id,
        returnLocationId: this.booking.ReturnLocation?.Id ?? this.booking.PickupLocation.Id,
        useInsurance: false,
        webBooking: true,
        actualReturnTime: null,
        createdAt: this.booking.CreatedAt?.toISOString() ?? moment().toDate().toISOString(),
        discountId: this.booking.DiscountId,
        addedProducts: this.booking.AddedProducts,

        //Customer current coordinated when creating the booking.
        bookingLat: currentCoordinates ? currentCoordinates.Latitude : null,
        bookingLng: currentCoordinates ? currentCoordinates.Longitude : null,

        useCurrentContext: this.appSettings.contextId == "KanLeiesUnmanned_API" ? true : false
      });


    this.Price = price;
    this.loadingPrice = false;
  }
}
